import { useRef } from "react";
import { useNearViewport } from "../../../hooks/useNearViewport";
import GoogleMapsFrame, { GoogleMapsFrameProps } from "../GoogleMapsFrame";
import styles from "../GoogleMapsFrame/GoogleMapsFrame.module.scss";

// How far outside the viewport the map starts loading.
const MAP_LOAD_MARGIN = "300px";

// GoogleMapsFrame that is only added when it nears the viewport, like LazyYouTube.
// The embed loads the Maps JavaScript API and map tiles, and the iframe's native
// loading="lazy" starts that 1250px+ away. Until then an empty box of the frame's
// size holds its place.
export default function LazyGoogleMapsFrame(props: GoogleMapsFrameProps) {
  const placeholderRef = useRef<HTMLDivElement>(null);
  const isNearViewport = useNearViewport(placeholderRef, MAP_LOAD_MARGIN);

  if (!isNearViewport) {
    return (
      <div
        ref={placeholderRef}
        className={styles.GoogleMapsFrame}
        style={{ backgroundColor: "#f2f2f2" }}
        aria-hidden
      />
    );
  }

  return <GoogleMapsFrame {...props} />;
}
